import {
    Image,
    Text,
    Group,
    Grid,
    Paper, Button, Stack,
} from '@mantine/core';
import React from "react";

const BookView = ({details})=>{
    return <Paper shadow={'md'} radius={10}>
        <Group>
        {details?.image && <Image src={details?.image} fit={'cover'}  height={60} width={60} p={2} radius={10} alt="img"/>}
            <Stack spacing={2}  sx={{flex: 1, flexDirection:'column'}}>
                <Text size='md' weight={500} style={{color:'steelblue'}} align={'left'}>{details?.title}</Text>
                <Text size='sm' color={'dimmed'} align={'left'}>By {details?.author}</Text>
            </Stack>
        </Group>
    </Paper>
}
export default BookView;
